const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
    customSenderEmail: null,
    teamMember: null,
};

export const settingsSlice = createSlice({
    initialState,
    name: 'settings',
    reducers: {
        setCustomSenderEmail: (state, action) => {
            let payload = null;

            if (action?.payload) {
                payload = { ...action.payload };
                payload['email'] = action?.payload?.email ?? action?.payload?.emailAddress;
            }

            state.customSenderEmail = payload;
        },
        setCompanyMembers: (state, action) => {
            state.teamMember = action.payload;
        },
    },
});

export const { setCustomSenderEmail, setCompanyMembers } = settingsSlice.actions;

export default settingsSlice.reducer;
